"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FtnvRequest = void 0;
var FtnvRequest = /** @class */ (function () {
    function FtnvRequest() {
    }
    return FtnvRequest;
}());
exports.FtnvRequest = FtnvRequest;
;
//# sourceMappingURL=ftnv.request.js.map